<template>
  <li class="user-comment">
    <div class="mt-2 mr-3">
      <vs-avatar class="m-0" :src="comment.user.image" icon-pack="feather" size="40px" @click="viewProfile(comment.user.id)"/>
    </div>
    <div>
      <div class="leading-tight comment-box">
        <p class="font-medium title mb-2" dir="ltr">
          <small dir="rtl" style="color: rgb(136, 153, 166)">{{ comment.created_at | ago }}</small>
          <span> . </span>
          <span class="text-dark cursor-pointer" @click="viewProfile(comment.user.id)">{{ comment.user.name }}</span>
        </p>
        <div class="leading-normal mb-1 whitespace-pre-wrap break-words" dir="auto">
          <p class="inline"> {{ commentBody }} </p>
          <span v-if="!seeMore && comment.body && comment.body.length > 300"
                class="text-primary cursor-pointer hover:underline whitespace-no-wrap font-bold" @click="seeMore = true">
            عرض المزيد
          </span>
        </div>

<!--        <p v-if="!editMode" class="mb-1 leading-normal">{{ commentBody }}</p>-->
<!--        <div v-else-if="comment.editMode" class="mb-1 ">-->
<!--          <div class="flex items-center">-->
<!--            <vs-input @keyup.enter.exact="updateComment(post)"-->
<!--                      @keyup.esc.exact="comment.editMode = false"-->
<!--                      class="input-rounded-full"-->
<!--                      v-model="comment.body" />-->
<!--            <vs-button v-if="!comment.image"-->
<!--                       class="mr-1" radius size="small" type="flat" icon-pack="feather" icon="icon-image"-->
<!--                       @click="commentUploadImageBtn(postIndex)" />-->
<!--            <vs-button class="ml-2 mr-1" size="small" icon-pack="feather" radius icon="icon-send"-->
<!--                       @click="updateComment(comment)"/>-->
<!--            <input @change="getCommentImage($event, postIndex)" ref="commentImageInput" accept="image/*" type="file" hidden>-->
<!--          </div>-->
<!--          <p @click="comment.editMode = false" class="m-2 text-primary text-sm cursor-pointer">قم بالضغط هنا لإلغاء التعديل او علي زر Esc</p>-->
<!--        </div>-->
      </div>
      <div v-if="comment.image" class="relative cursor-pointer sm:max-w-xs max-w-full">
        <img class="mt-2 rounded-xl sm:max-w-xs max-w-full"
             :src="comment.image"
             @click="viewImage(comment.image)" alt="">
        <vs-button v-if="editMode"
                   @click="comment.image = null"
                   class="absolute top-0 left-0 mt-2 mr-2" size="small" radius icon-pack="feather" icon="icon-x" color="danger" />
      </div>
    </div>
    <div class="my-auto mr-1">
      <vs-dropdown v-if="isTeacher || comment.user.id === user.id" class="effect-dropdown cursor-pointer ml-3" vs-custom-content vs-trigger-click>
        <feather-icon icon="MoreHorizontalIcon" svgClasses="w-5 h-5" />
        <vs-dropdown-menu>
          <!--<vs-dropdown-item @click="comment.editMode = true">-->
          <!--<feather-icon icon="EditIcon" svgClasses="w-4 h-4"></feather-icon>-->
          <!--<span class="ml-2">تعديل</span>-->
          <!--</vs-dropdown-item>-->
          <vs-dropdown-item @click="deleteComment" class="flex items-center">
            <feather-icon icon="TrashIcon" svgClasses="w-4 h-4"></feather-icon>
            <span class="ml-2">حذف</span>
          </vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>
    </div>
  </li>
</template>

<script>
    import commentsAPI from "@/api/commentsAPI"

    export default {
        name: "PostComment.vue",
        props: {
            comment: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                seeMore: false,
                editMode: false,
            }
        },
        computed: {
            commentBody() {
              if(!this.seeMore && this.comment.body && this.comment.body.length > 300) {
                return this.comment.body.substring(0, 250) + '...'
              } else {
                return this.comment.body
              }
            }
        },
        methods: {
            // updateComment(comment){
            //     let commentData = new FormData()
            //     commentData.append('id', comment.id)
            //     commentData.append('body', comment.body)
            //
            //     commentsAPI.update(comment.id, commentData, this.course_id)
            //         .then( ({data}) => {
            //             console.log(data)
            //         })
            //     comment.editMode = false
            // },
            deleteComment(){
                commentsAPI.delete(this.comment.id)
                    .then( () => this.$emit('deleted', this.comment.id))
                    .catch(error => this.$notifyError(error.statusMessage))
            },
            viewImage(src){
                this.$emit('viewImage', src)
            },
        },
    }
</script>

<style lang="scss">
  .comment-image-holder {
    height: 150px;
    width: 350px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }
  /*.user-comment:hover .vs-con-dropdown,*/
  /*.vs-con-dropdown:focus {*/
  /*  display: inline-block !important;*/
  /*}*/
  .comment-box{
    padding: 10px 20px;
    background-color: #f2f3f5;
    border-radius: 18px;
    color: #1c1e21;
    margin: 0;
    max-width: 100%;
    word-wrap: break-word;
    position: relative;
    white-space: normal;
    word-break: break-word;
  }
</style>
